var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label-info wow fadeInUp",attrs:{"data-wow-delay":"0.5s"}},[_c('div',{staticClass:"left"},[_vm._v(" >>>>>>>> ")]),_c('div',{staticClass:"right"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }